// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum RefundCounterpartyOverridability {
  Allowed = "ALLOWED",
  Required = "REQUIRED",
  Denied = "DENIED",
}
export default RefundCounterpartyOverridability;
